"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.COLOR = void 0;
var COLOR = {
  black: '#575E68',
  blackDark: '#111111',
  grey: '#BABFC3',
  greyOpacity01: 'rgba(46, 46, 46,0.1)',
  greyLight: '#F4F6F8',
  greyLight2: '#acb8b9',
  blue: '#6270C6',
  darkBlue: '#084E8A',
  blueLight: '#939DD6',
  facebookBlue: '#1877F2',
  redOrange: '#C05717',
  redLight: '#EF5350',
  red: '#C64242',
  green: '#008060',
  orange: '#DF8702',
  white: '#FFFFFF',
  whiteSoft: '#fcfcfd',
  fixelYellow: '#F2BE41'
};
exports.COLOR = COLOR;